import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { activateBusinessManualAction } from "../../actions/businessInfo";

const plans = [
  {
    name: "Wealth Retention - Unlicensed",
    detail:
      "For founders, investors, family structures, and holding companies retaining their own assets or capital in Singapore.",
  },
  {
    name: "Wealth Retention - Licensed (SFO)",
    detail:
      "For a Single Family Office managing one family's assets under a Singapore S13O or S13U structure.",
  },
  {
    name: "Wealth Retention - Licensed (MFO)",
    detail:
      "For a Multi-Family Office managing assets for multiple families or third-party clients. Custom quotation required.",
  },
  {
    name: "Trade Efficiency - Unlicensed",
    detail:
      "For import/export companies, consultants, professional service providers, and other cross-border operating businesses.",
  },
  {
    name: "Trade Efficiency - Licensed (PSPM)",
    detail:
      "For dealers in precious stones, precious metals, jewellery, or bullion requiring PSPM registration.",
  },
  {
    name: "Capital Access - Unlicensed",
    detail:
      "For startups, SPVs, holding companies, and growth-stage businesses preparing to raise capital from investors.",
  },
  {
    name: "Capital Access - Licensed (VCC)",
    detail:
      "For fund managers raising and managing third-party investor capital through a licensed or exempt VCC structure. Custom quotation required.",
  },
  {
    name: "Digital Assets - Unlicensed",
    detail:
      "For crypto businesses, blockchain companies, token-holding structures, and digital platforms that do not require an MAS payment licence.",
  },
  {
    name: "Digital Assets - Licensed (MAS PI)",
    detail:
      "For crypto exchanges, payment service providers, custody businesses, and other digital-asset operations requiring an MAS Payment Institution licence. Custom quotation required.",
  },
];

const getToday = () => new Date().toISOString().slice(0, 10);

export default function ActivationPlanModal({ show, onClose, company, filterBody, onActivated }) {
  const dispatch = useDispatch();
  const today = getToday();
  const [selectedPlan, setSelectedPlan] = useState("");
  const [planDetail, setPlanDetail] = useState("");
  const [expiryDate, setExpiryDate] = useState(today);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      setSelectedPlan("");
      setPlanDetail("");
      setExpiryDate(today);
      setLoading(false);
    }
  }, [show, today]);

  const selectedPlanDetail = plans.find((item) => item.name === selectedPlan);

  useEffect(() => {
    if (selectedPlanDetail) {
      setPlanDetail(selectedPlanDetail.detail);
    }
  }, [selectedPlanDetail]);

  const handleSubmit = async () => {
    const payload = {
      companyId: company?._id,
      planName: selectedPlan,
      planDetail,
      startDate: today,
      expiryDate,
    };

    setLoading(true);
    const resp = await dispatch(activateBusinessManualAction(payload, filterBody));
    setLoading(false);
    if (resp.status) {
      onActivated && onActivated(resp.company || resp.data?.company);
      onClose();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      className="moddal-width companyEdit-modal ps-0 add-modal"
    >
      <div className="modal-header pt-2">
        <button
          type="button"
          className="btn-close text-dark close-button"
          onClick={onClose}
        >
          &nbsp;
        </button>
      </div>
      <div className="modal-body pb-0">
        <div className="row">
          <div className="col-12 text-center mb-3">
            <h5 className="mb-2">Activate business manually</h5>
            <p className="mb-0">
              <strong>{company?.companyName}</strong>
            </p>
          </div>
          <div className="col-12 mb-3">
            <label className="form-label">Plan name</label>
            <select
              className="form-control"
              value={selectedPlan}
              onChange={(e) => setSelectedPlan(e.target.value)}
              required
            >
              <option value="">Select plan</option>
              {plans.map((item) => (
                <option key={item.name} value={item.name}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 mb-3">
            <label className="form-label">Plan detail</label>
            <textarea
              className="form-control"
              rows={4}
              value={planDetail}
              onChange={(e) => setPlanDetail(e.target.value)}
              required
            />
          </div>
          <div className="col-12 mb-3">
            <label className="form-label">Renewal date</label>
            <input
              className="form-control"
              type="date"
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
              required
            />
          </div>
          <div className="row mb-3">
            <div className="col-md-3"></div>
            <div className="col-md-3 cancelbox">
              <button
                type="button"
                onClick={onClose}
                className="btn save-btn confirm m-0"
              >
                close
              </button>
            </div>
            <div className="col-md-3">
              <button
                className="btn save-btn cancel m-0"
                onClick={handleSubmit}
                disabled={loading || !selectedPlan || !planDetail || !expiryDate}
                type="button"
              >
                {loading ? "Activating..." : "Activate"}
              </button>
            </div>
            <div className="col-md-3"></div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
